import logo from './img/caffè/logoCaffè.png';
import caffetteria from './img/caffè/caffetteria.png';
import specialità from './img/caffè/specialità.png';
import cocktail from './img/caffè/cocktail.png';
import cocktail_2 from './img/caffè/cocktail_2.png';
import spritz from './img/caffè/spritz.png';
import aperitivo from './img/caffè/aperitivo.png';
import qr from './img/caffè/qr.png';
import tel from './img/caffè/tel.png';
import space from './img/caffè/space.png'
import React from 'react';
import './App.css';
import { useHistory } from "react-router-dom";
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

function Caffè() {
    const history = useHistory();

    const buttonMenuClick = ()=>  {
      history.push("/menu_qr");
    }
    const ColorButton = styled(Button)(({ theme }) => ({
      marginBottom: "8%",
        fontSize: "15%",
        color: theme.palette.getContrastText("#fff3d7"),
        backgroundColor: "#fff3d7",
        '&:hover': {
          backgroundColor: "#e3c563",
        },
      }));
    return (
        <React.Fragment key={3}>
            <div className="Content-caffe">
                <img src={logo} alt="home" className="menu"/>
                <ColorButton onClick={buttonMenuClick} variant="contained" className="buttonCaffe">Menu</ColorButton>
                {/* <img src={buttonMenu} alt="buttonCaffe" className="buttonCaffe" onClick={buttonMenuClick}/> */}
                <img src={caffetteria}  alt="caffetteria" className="foto"/>
                <img src={specialità}  alt="specialità" className="foto"/>
                <img src={space}  alt="specialità" className="space"/>
                <img src={cocktail}  alt="cocktail" className="foto"/>
                <img src={cocktail_2}  alt="cocktail_2" className="foto"/>
                <img src={space}  alt="specialità" className="space"/>
                <img src={spritz}  alt="spritz" className="foto"/>
                <img src={aperitivo}  alt="aperitivo" className="foto"/>
                <img src={space}  alt="specialità" className="space"/>
                <img src={space}  alt="specialità" className="space"/>
                <img src={qr}  alt="qr" className="foto"/>
                <img src={space}  alt="specialità" className="space"/>
                <img src={tel}  alt="tel" className="foto"/>
                <img src={space}  alt="specialità" className="space"/>
            </div>
        </React.Fragment>)
    }
export default Caffè;